<template>
  <div id="app">
    <router-view v-if="routerAlive" />
    <div class="order-message" v-drag="'drag'" v-if="platformOrderMessage.show">
      <div class="close-icon" ref="drag">
        <span id="drag">超时未到分仓</span>
        <el-tooltip
          class="item"
          effect="light"
          content="以下单据已出库，但超时未到分仓，请检查实物是否发出。若已发出且分仓收货，单据状态为‘已到分仓’"
          placement="bottom"
        >
          <span class="el-icon-question"></span>
        </el-tooltip>
        <i class="el-icon-close" @click="closePlatformMessage"></i>
      </div>
      <div class="content">
        <div class="order" @click="goOrderRoute">
          订&nbsp;&nbsp;&nbsp;单：<span>{{
            platformOrderMessage.orderCount
          }}</span
          >(单)
        </div>
        <div class="aftersale-order" @click="goAfterOrderRoute">
          售后单：<span>{{ platformOrderMessage.asOrderCount }}</span
          >(单)
        </div>
      </div>
    </div>
    <!-- 公告弹框 -->
    <!-- <NoticeDialog></NoticeDialog> -->
    <!-- 待处理工单列表 -->
    <PendingOrderDialog />
  </div>
</template>

<script>
import "./directive/drag";
import { mapGetters } from "vuex";
import PendingOrderDialog from "./components/pendingOrder";

export default {
  name: "App",
  components: {
    PendingOrderDialog
  },
  provide() {
    return {
      routeReload: this.routeReload
    };
  },
  data() {
    return {
      routerAlive: true,
      platformNoArrivedOrder: {},
      isJgj: localStorage.getItem("is_jgj")
    };
  },
  computed: {
    showPlatformNoArrivedMessage: {
      set(value) {
        return value;
      },
      get() {
        if (this.platformNoArrivedOrder) {
          return true;
        } else {
          return false;
        }
      }
    },
    ...mapGetters(["platformOrderMessage", "roles"])
  },
  methods: {
    routeReload() {
      this.routerAlive = false;
      this.$nextTick(function () {
        // setTimeout(()=>{
        this.routerAlive = true;
        // },10)
      });
    },
    closePlatformMessage() {
      this.$store.dispatch("platform/switchPlatformOrderMessageShow", false);
    },
    goOrderRoute() {
      sessionStorage.setItem("order_tab_index", 4);
      sessionStorage.setItem("order_tab_index_pageIndex", 1);
      localStorage.setItem("orderOutwareTimeout", 1);
      if (isJgj === "1") {
        // 为紧固件的时候
        if (this.$route.fullPath === "/order/manageFastener") {
          this.routeReload();
        } else {
          this.$router.push("/order/manageFastener");
        }
      } else {
        if (this.$route.fullPath === "/order/manage") {
          this.routeReload();
        } else {
          this.$router.push("/order/manage");
        }
      }
    },
    goAfterOrderRoute() {
      localStorage.setItem("afterorderOutwareTimeout", 1);
      localStorage.setItem("afterSaleTabIndex", 3);
      if (this.$route.fullPath === "/afterSale/manage") {
        this.routeReload();
      } else {
        this.$router.push("/afterSale/manage");
      }
    }
  },
  mounted() {
    // console.log(
    //   "isFirst-----------app--------------:",
    //   localStorage.getItem("first_login")
    // );
    // 见证宝最后加载
    // console.log(this.roles, "this.roles");
    if (this.roles.length > 0 && !this.roles.includes("r4gys")) {
      console.log(localStorage.getItem("is_r4gys"), "is_r4gys");
      this.$store.dispatch("user/getJzbInfo");
    }
  }
};
</script>
<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.order-message {
  position: fixed;
  bottom: 10px;
  right: 20px;
  z-index: 10;
  background: #ffffff;
  // padding:10px;
  width: 180px;
  border: 0.5px solid #212a32;
  border-radius: 5px;
  // height: 70px;
  box-shadow: 2px 2px 4px 2px #d0cfcf;
  .content {
    margin-top: 4px;
    font-size: 14px;
    padding: 15px;
    .order {
      margin-bottom: 12px;
    }
    div {
      cursor: pointer;
    }
    span {
      color: red;
      display: inline-block;
      padding-right: 5px;
    }
  }
  .close-icon {
    cursor: move;
    border-radius: 5px 5px 0 0;
    text-align: left;
    background: #212a32;
    // font-weight: 600;
    color: #fff;
    padding: 7px;
    line-height: 1;
    font-size: 14px;
    i {
      cursor: pointer;
      position: absolute;
      top: 5px;
      right: 5px;
      color: #fff;
      cursor: pointer;
      font-size: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue